import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
  TextField as MuiTextField,
  FormHelperText,
  Grid
} from '@material-ui/core';

import useStyles from './commonStyles';

import ToolTip from '../tooltip';

const OutlinedTextField = React.memo(props => {
  const classes = useStyles();
  let { label, name, value, onChange, disabled, maxLength, helperText, tooltip, ...rest } = props;
  let changeHandler = onChange;
  const fieldRef = useRef(null);
  const [ tooltipOpen, setTooltipOpen ] = useState(false);
  let hasTooltip = !!tooltip;

  if(typeof value !== 'string') {
    value = '';
  }

  if(maxLength) {
    changeHandler = event => {
      if(event.target.value.length <= maxLength) {
        onChange(event);
      }
    }
  }

  const handleFocus = event => {
    if(hasTooltip) {
      setTooltipOpen(true);
    }
  }

  const handleBlur = event => {
    if(hasTooltip) {
      setTooltipOpen(false);
    }
  }

  return (
    <>
      <MuiTextField
        label={label}
        name={name}
        value={value}
        onChange={changeHandler}
        disabled={disabled}
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          classes: {
            root: classes.textFieldInput
          },
          ref: fieldRef
        }}
        variant="outlined"
        {...rest}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {(helperText || maxLength)
        ?
        <FormHelperText variant="outlined" component="div" error={rest.error}>
          <Grid container justifyContent="space-between">
            <Grid item style={{marginRight: '5px'}}>{helperText || ''}</Grid>
            <Grid item>{maxLength ? `${value.length}/${maxLength}` : ''}</Grid>
          </Grid>
        </FormHelperText>
        : null
      }
      {
        hasTooltip
          ?
          <ToolTip
            open={tooltipOpen}
            anchorElRef={fieldRef}
            content={tooltip}
            arrow
          >
            {tooltip}
          </ToolTip>
          :
          null
      }
    </>
  );
});

OutlinedTextField.displayName = 'OutlinedTextField';
OutlinedTextField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  maxLength: PropTypes.number,
  tooltip: PropTypes.node
};

export default OutlinedTextField;
